import {
  AlertCircle,
  Archive,
  BarChart3,
  BookOpen,
  Bot,
  Building2,
  Check,
  CheckCircle2,
  CircleCheck,
  CircleOff,
  Clock,
  Cloud,
  Cpu,
  FileCode,
  FileText,
  FolderOpen,
  GitBranch,
  Handshake,
  HardDrive,
  Inbox,
  Layers,
  Link,
  Loader2,
  LogOut,
  Menu,
  MessageCircle,
  Camera,
  Minus,
  Newspaper,
  Pencil,
  Plug,
  Plus,
  Radio,
  RefreshCw,
  Server,
  Shield,
  Sparkles,
  UserRound,
  Users,
  X,
  XCircle,
} from 'lucide-react';
import { isAdmin, isUser, canManageTeam } from './accountFunction';

export const USER_PRIMARY_NAV_ITEMS = [
  { to: '/agents', label: 'Agentes', icon: Bot },
  { to: '/contacts', label: 'Contatos', icon: UserRound },
  { to: '/analysis-reports', label: 'Análises', icon: BarChart3 },
  { to: '/knowledge-bases', label: 'Conhecimento', icon: BookOpen },
  { to: '/scheduled-messages', label: 'Agendamentos', icon: Clock },
];

export const USER_SECONDARY_BASE_ITEMS = [
  { to: '/channels', label: 'Canais', icon: Radio },
  { to: '/mcp-servers', label: 'MCP', icon: Plug },
  { to: '/onboarding', label: 'Criar agente', icon: Plus },
];

/** @deprecated use getUserNavSections */
export const USER_NAV_ITEMS = [
  ...USER_PRIMARY_NAV_ITEMS,
  ...USER_SECONDARY_BASE_ITEMS,
];

const TEAM_NAV_ITEM = { to: '/team', label: 'Equipe', icon: Users };

const INBOUND_ROUTER_NAV_ITEM = {
  to: '/inbound-routers',
  label: 'Roteamento',
  icon: GitBranch,
};

const EDGE_CONNECTOR_NAV_ITEM = {
  to: '/edge-connectors',
  label: 'Edge',
  icon: Server,
};

export function getUserNavSections(user, { isMultiAgent = false, currentMembership = null } = {}) {
  if (!isUser(user)) {
    return { primary: [], secondary: [] };
  }

  const secondary = [...USER_SECONDARY_BASE_ITEMS];
  if (isMultiAgent) {
    secondary.push(INBOUND_ROUTER_NAV_ITEM);
  }
  secondary.push(EDGE_CONNECTOR_NAV_ITEM);
  if (canManageTeam(currentMembership)) {
    secondary.push(TEAM_NAV_ITEM);
  }

  return {
    primary: USER_PRIMARY_NAV_ITEMS,
    secondary,
  };
}

export const ADMIN_NAV_ITEMS = [
  { to: '/admin/accounts', label: 'Contas', icon: Building2 },
  { to: '/admin/agents', label: 'Agentes', icon: Bot },
  { to: '/admin/channels', label: 'Canais', icon: Radio },
  { to: '/admin/contacts', label: 'Contatos', icon: Users },
  { to: '/admin/scheduled-messages', label: 'Agendamentos', icon: Clock },
  { to: '/llm-catalog', label: 'Catálogo LLM', icon: Cpu },
  { to: '/prompt-templates', label: 'Prompts', icon: FileCode },
  { to: '/whatsapp-catalog', label: 'WhatsApp', icon: MessageCircle },
  { to: '/instagram', label: 'Instagram', icon: Camera },
];

export function getNavItems(user, { isMultiAgent = false, currentMembership = null } = {}) {
  if (isAdmin(user)) {
    return ADMIN_NAV_ITEMS;
  }
  if (isUser(user)) {
    const { primary, secondary } = getUserNavSections(user, {
      isMultiAgent,
      currentMembership,
    });
    return [...primary, ...secondary];
  }
  return [];
}

export const KB_STATUS_ICONS = {
  pending: Clock,
  ingesting: Loader2,
  syncing: RefreshCw,
  active: CheckCircle2,
  error: AlertCircle,
};

export const KB_STATUS_SHORT_LABELS = {
  pending: 'Pendente',
  ingesting: 'Processando',
  syncing: 'Indexando',
  active: 'Ativo',
  error: 'Erro',
};

export const IMPORT_FILE_STATUS_ICONS = {
  pending: Clock,
  processing: Loader2,
  completed: Check,
  failed: XCircle,
  skipped: Minus,
  removed: Archive,
};

export const IMPORT_FILE_STATUS_SHORT_LABELS = {
  pending: 'Pendente',
  processing: 'Processando',
  completed: 'Concluído',
  failed: 'Falhou',
  skipped: 'Ignorado',
  removed: 'Removido',
};

export const AGENT_STATUS_ICONS = {
  active: CircleCheck,
  inactive: CircleOff,
};

export const AGENT_STATUS_SHORT_LABELS = {
  active: 'Ativo',
  inactive: 'Inativo',
};

export const SOURCE_TYPE_ICONS = {
  url: Link,
  s3: Cloud,
  google_drive: HardDrive,
  contentful: Newspaper,
  file_to_text: FileText,
  manual: Pencil,
};

export const SUB_AGENT_TYPE_ICONS = {
  onboarding: Handshake,
  skills: Sparkles,
  guardrails: Shield,
  human_loop: UserRound,
};

export const EMPTY_STATE_ICONS = {
  agents: Bot,
  knowledgeBases: BookOpen,
  files: FolderOpen,
  inbox: Inbox,
};

export function getStatusIcon(kind, status) {
  const maps = {
    kb: KB_STATUS_ICONS,
    importFile: IMPORT_FILE_STATUS_ICONS,
    agent: AGENT_STATUS_ICONS,
  };
  return maps[kind]?.[status] || null;
}

export function statusShouldSpin(kind, status) {
  return (
    (kind === 'kb' && (status === 'ingesting' || status === 'syncing')) ||
    (kind === 'importFile' && status === 'processing')
  );
}

export { LogOut, Menu, X, Layers };
